import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IStudentSearchParameters } from 'src/app/Models/IStudentSearchParameters';
import { IServiceProviderSearchParameters } from 'src/app/Models/IServiceProviderSearchParameters';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { IStudentByProviderSearchParameters } from '../../../Models/IStudentByProviderSearchParameters';

@Component({
  selector: 'app-_320_IEPBatchPrintReports',
  templateUrl: './_320_IEPBatchPrintReports.component.html',
  styleUrls: ['./_320_IEPBatchPrintReports.component.css']
})
export class _320_IEPBatchPrintReportsComponent implements OnInit {
  _baseUrl: string;
  _myGlobals: Globals;
  isReportButtonDisabled: boolean = true;
  isPAUSelected: boolean = false;
  reportFileName: string;
  schoolStartDate: Date;

  date: Date; //datepicker
  selectedPAU: SelectItem;
  selectedSite: SelectItem;
  selectedServiceProvider: string;
  selectedGradeLevel: SelectItem;
  selectedDisability: SelectItem;
  selectedStudent: string;
  selectedReport: SelectItem;//dropdown
  _PAUid: string = null;
  _siteId: string = null; 
  _selectedGradeLevel: string = null;
  _selectedDisability: string = null;
  _selectedStudent: string = null;//dropdown
  _reportId: string = null;//dropdown
  radioBtnSelection: string = 'English';  //radiobutton
  public showSpinner: boolean = false;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupReportsList: ILookupBase[] = [{ value: null, label: "-- NO REPORTS ! --", shortText: null, updatedOn: null }];
  lookupGradeLevelList: ILookupBase[];
  lookupDisabilityList: ILookupBase[] = [{ value: null, label: "-- NO DISABILITIES TO VIEW ! --", shortText: null, updatedOn: null }];
  lookupSProvidersList: ILookupBase[] = [{ value: null, label: "-- NO SERVICE PROVIDERS ! --", shortText: null, updatedOn: null }];
  lookupStudentList: ILookupBase[] = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- NO PAUs --", shortText: null, updatedOn: null }];
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService,
    @Inject('BASE_URL') baseUrl: string, reportService: ReportService) {  
    this._lookupService = lookupService;
    this._baseUrl = baseUrl;
    this._reportService = reportService;
    this.date = new Date();
  }

  ngOnInit() {
    this.lookupGradeLevelList = [{ value: null, label: "-- All Grade Levels --", shortText: null, updatedOn: null },
      { value: "6", label: "6", shortText: null, updatedOn: null },
      { value: "7", label: "7", shortText: null, updatedOn: null },
      { value: "8", label: "8", shortText: null, updatedOn: null },
      { value: "9", label: "9", shortText: null, updatedOn: null },
      { value: "10", label: "10", shortText: null, updatedOn: null },
      { value: "11", label: "11", shortText: null, updatedOn: null },
      { value: "12", label: "12", shortText: null, updatedOn: null }];
    this.selectedGradeLevel = this.lookupGradeLevelList[0];
    let today = new Date();
    let lastYear: number = today.getFullYear() - 1;
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());

    if (today.getMonth() >= 6) {
      this.schoolStartDate = new Date(7 + '/' + 1 + '/' + today.getFullYear());
    } else {
      this.schoolStartDate = new Date(7 + '/' + 1 + '/' + lastYear);
    }


    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Disability])
      .subscribe((res: ILookupBase[]) => {
        this.lookupDisabilityList = [{ value: null, label: "-- All Disabilities --", shortText: null, updatedOn: null }].concat(res);
        this.selectedDisability = this.lookupDisabilityList[0];
      },
        err => console.error(err)
      );

    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupPAUList = [{ value: null, label: "-- NO PAUS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupPAUList = [{ value: null, label: "-- Select a PAU --", shortText: null, updatedOn: null }].concat(res);
          this.selectedPAU = this.lookupPAUList[0];
        }

        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0];

              //Service Provider Lookup
              this.getProviderOptions();

              this.getStudentOptions();
            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
    );

    this._lookupService.getLookupReports(this._baseUrl + 'api/Lookup/GetBatchPrintReportList/' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupReportsList = [{ value: null, label: "-- NO REPORTS TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupReportsList = [{ value: null, label: "-- Select one Batch Report to Print --", shortText: null, updatedOn: null }].concat(res);
          this.selectedReport = this.lookupReportsList[0];
        }
      },
        err => console.error(err)
      );
  }

  getProviderOptions() {
    let serviceProviderParams: IServiceProviderSearchParameters = {} as IServiceProviderSearchParameters;
    serviceProviderParams.startDate = this.date;
    serviceProviderParams.endDate = this.date;
    serviceProviderParams.siteIdArray = this.getSiteIdList().split('^');


    this._lookupService.getLookupServiceProviders(this._baseUrl + 'api/Lookup/GetServiceProviderList/', serviceProviderParams)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSProvidersList = [{ value: null, label: "-- NO SERVICE PROVIDERS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSProvidersList = [{ value: null, label: "-- All Service Providers --", shortText: null, updatedOn: null }].concat(res);
          this.selectedServiceProvider = null
          this.getStudentOptions();
        }
      },
        err => console.error(err)
      );
  }

  getStudentOptions() {
    if (this.selectedServiceProvider === null || this.selectedServiceProvider === undefined) {
      //Student lookup (no service provider selected)
      let params = {} as IStudentSearchParameters;
      params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
      params.siteIdArray = this.getSiteIdList().split('^');

      this._lookupService.getLookupStudentByProvider(this._baseUrl + 'api/Lookup/GetStudentList/', params)
        .subscribe((res: ILookupBase[]) => {
          if (!res || res.toString() === "") {
            this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }]
          }
          else {
            this.lookupStudentList = [{ value: null, label: "-- All Students --", shortText: null, updatedOn: null }].concat(res);
            this.selectedStudent = null;
          }
        },
          err => console.error(err)
        );
    }
    else {
      //service provider selected
      let params = {} as IStudentByProviderSearchParameters;
      params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
      params.siteIdArray = this.getSiteIdList().split('^');
      params.userIdArray = [this.selectedServiceProvider];

      this._lookupService.getLookupStudentByProvider(this._baseUrl + 'api/Lookup/GetStudentListByProvider/', params)
        .subscribe((res: ILookupBase[]) => {
          if (!res || res.toString() === "") {
            this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }]
          }
          else {
            let idList: string[] = res.map((r: ILookupBase) => r.value);
            let allStudentString: string = idList.join('^');
            //selectedIds = myObj.map(({ id }) => id);
            this.lookupStudentList = [{ value: allStudentString, label: "-- All Students --", shortText: null, updatedOn: null }].concat(res);
            this.selectedStudent = allStudentString;
          }
        },
          err => console.error(err)
        );
    }
  }

  LookupSites(id): void {
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/getLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
          this.selectedSite = this.lookupSiteList[0];
          this.getProviderOptions();
        }
      },
        err => console.error(err)
      );
  }

  onPauChanged(event) {
    this._PAUid = event.value;

    if (event.value == null) {
      this.isPAUSelected = false;
    }
    else {
      this.isPAUSelected = true;
    }

    this.ControlReportButtonEnablement();

    this.LookupSites(event);
  }

  onSiteChanged(event): void {
    this._siteId = event.value;

    this.getProviderOptions();
  }
  setGradeLevel(id): void {
    this._selectedGradeLevel = id.value;
  }
  setDisability(id): void {
    this._selectedDisability = id.value;
  }
  setServiceProvider(id): void {
    this.getStudentOptions();
  }
  setStudent(id): void {
    this._selectedStudent = id.value;
  }
  setReport(id): void {
    this._reportId = id.value;
    if (id.value == null) {
      this.isReportButtonDisabled = true;
    }
    else {
      this.isReportButtonDisabled = false;
    }

    this.ControlReportButtonEnablement();

    if (id.value == null) {
      this.reportFileName = "";
    }
    else {
      this.reportFileName = id.value.replace("/ SpedXReports /", "");
    }

  }
  checkRadioButton(id): void {
    this.radioBtnSelection = id;
  }

  getSiteIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '').replace('null', '');
    }
  }

  getStaffIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '').replace('null', '');
    }
  }

  getSelectedDateData() {
    this.LoadLookupValues();
  }

  getstudentIdList(): string {
    let studentIdList: string = null;
    this.lookupStudentList.forEach((std, index, arr) => {
      if ((std.label != null) && (std.label != "-- NO STUDENTS TO VIEW --")) {
        if (std.label != "-- All Students --") studentIdList += std.value + '^';
      }
    });

    if (this.selectedStudent == 'AlL') {
      return 'All';
    }
    else {
      return studentIdList.slice(0, studentIdList.length - 1).replace('undefined', '').replace('null', '');
    }

  }

  getGradeIdList(): string {
    let gradeIdList: string = null;
    this.lookupGradeLevelList.forEach((grd, index, arr) => {
      if ((grd.label != null) && (grd.label != "-- NO GRADES TO VIEW --")) {
        if (grd.label != "-- All Grade Levels --") gradeIdList += grd.label + '^';
      }
    });

    if (this.selectedGradeLevel.label == '-- All Grade Levels --') {
      return 'All';
    }
    else {
      return gradeIdList.slice(0, gradeIdList.length - 1).replace('undefined', '').replace('null', '');
    }
  }

  getDisabilityIdList(): string {
    let disabilityIdList: string = null;
    this.lookupDisabilityList.forEach((dis, index, arr) => {
      if ((dis.label != null) && (dis.label != "-- NO DISABILITIES TO VIEW ! --")) {
        if (dis.label != "-- ALL DISABILITIES --") disabilityIdList += dis.value + '^';
      }
    });
    

    if (this.selectedDisability.label == '-- All Disabilities --') {
      return 'All';
    }
    else {
      return disabilityIdList.slice(0, disabilityIdList.length - 1).replace('undefined', '').replace('null', '');
    }

  }

  ControlReportButtonEnablement() {
    if (this._reportId == null || this.isPAUSelected == false) {
      this.isReportButtonDisabled = true;
    }
    else {
      this.isReportButtonDisabled = false;
    }
  }

  viewReport() {
    let reportParamArray: IReportParameter[] = [];
    var selectedPAUValue = this.lookupPAUList.find(x => x.value === this._PAUid).label;
    var selectedSiteValue = this.lookupSiteList.find(y => y.value === this._siteId).label;
    var selectedStudentValue = this.lookupStudentList.find(z => z.value === this.selectedStudent).label;
    var selectedReportName = this.lookupReportsList.find(k => k.value === this._reportId).label;
    var selectedDisabilityLabel = this.lookupDisabilityList.find(j => j.value === this._selectedDisability).label;

    reportParamArray.push(
      { parameterName: 'SelectedPauName', parameterValue: (this.selectedPAU != null && selectedPAUValue != '-- All PAUs --') ? selectedPAUValue.replace('-- ', '').replace(' --', '')  : 'All PAUs' },
      { parameterName: 'SelectedSiteName', parameterValue: (this.selectedSite != null && selectedSiteValue != "-- Select PAU to view sites --") ? selectedSiteValue.replace('-- ', '').replace(' --', '') : 'All Sites' },
      { parameterName: 'StartingDate', parameterValue: this.schoolStartDate.toISOString().slice(0, 10) }, 
      { parameterName: 'SiteIdList', parameterValue: this.getSiteIdList().replace('undefined', '') },
      { parameterName: 'StudentIdList', parameterValue: this.getstudentIdList() },
      { parameterName: 'StudentName', parameterValue: this.selectedStudent != null && selectedStudentValue != '-- All Students --' ? selectedStudentValue : 'All Students' },
      { parameterName: 'GradeList', parameterValue: this.getGradeIdList() }, 
      { parameterName: 'GradeName', parameterValue: this._selectedGradeLevel != null && this._selectedGradeLevel != '-- All Grade Levels --' ? this._selectedGradeLevel : 'All Grades' },
      { parameterName: 'DisabilityList', parameterValue: this.getDisabilityIdList() },  
      { parameterName: 'DisabilityName', parameterValue: this.selectedDisability != null && selectedDisabilityLabel != '-- All Disabilities --' ? selectedDisabilityLabel : 'All Disability' },
      { parameterName: 'SelectedReportName', parameterValue: selectedReportName },
      { parameterName: 'EndingDate', parameterValue: this.date.toISOString().slice(0, 10) }  
    );

    let now = new Date();
    let localReportFileName = '320-IEP_BatchPrint_' + now.toISOString().slice(0, 10) + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = this.reportFileName;  
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this.showSpinner = true;
    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
